/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */

import { GET_USER_DETAILS_FOR_ADMIN_FAILURE, GET_USER_DETAILS_FOR_ADMIN_REQUEST, GET_USER_DETAILS_FOR_ADMIN_SUCCESS } from "./userAdminDetailsTypes";
  
  const initialStateForRoles = {
    loading: false,
    rolesData: [],
    error: "",
  };
  
  const getUserDetailsForAdminReducer = (state = initialStateForRoles, action) => {
    switch (action.type) {
      case GET_USER_DETAILS_FOR_ADMIN_REQUEST:
        return {
          ...state,
          loading: true,
        };
      case GET_USER_DETAILS_FOR_ADMIN_SUCCESS:
        return {
          loading: false,
          rolesData: action.payload,
          error: "",
        };
      case GET_USER_DETAILS_FOR_ADMIN_FAILURE:
        return {
          loading: false,
          rolesData: [],
          error: action.payload,
        };
      default:
        return state;
    }
  };

  
  export { getUserDetailsForAdminReducer };
  